import $ from 'jquery';
import EventDispatcher from '@/base/event/event-dispatcher';
import ObserverPage from '@/base/module/observer/observer-page';
import { getWH } from '@/components/player/media';
import Zoom from '@/components/zoom';
import ScreenFull from '@/components/screenfull';

import './tmpl/view.scss';
import tmpl from './tmpl/_view.art';

function createImage(src, callback) {
    let img = new Image();
    img.onload = img.onerror = evt => {
        if(evt.type === 'error') {
            this.dispatchEvent('error', this);
        } else {
            this.$el.css({ height: 'auto'});
            this.$box.append(evt.target);
            this.$loading.hide();
        }
        this.dispatchEvent('loaded', this);
    };
    img.src = src;
    return img;
}

class PageView extends EventDispatcher {

    /**
     * @param { Object } options 页面加载所需要参数
     *     src: 资源地址（图片地址）
     *     index: 当前页的索引
     *     $parent: 父级元素
     *     lazy: true 默认加载页面内容; false 只做页面占位不加载展示内容
     * @param { Object } screen 每页的宽高值：width, height
     */
    constructor(options) {
        super();
        this.options = options;
        this.removeMark = false;
        this.$parent = options.$parent || $('body');
        this.screen = getWH(); // 获取展示区域宽高
        this.render();
        this.load(options.lazy);
        // if (this.screen.clientWidth >= this.screen.standard) { // 大屏
            this.initZoom();
        // }
        // if (this.screen.clientWidth >= this.screen.standard) { // 大屏
            // 全屏 iframe中无效
        //     this.initScreenFull()
        // }
    }

    initZoom() {
        if (this.options.index == 1) {
            this.zoom = new Zoom(this.options);
        }
    }

    initScreenFull() {
        if (this.options.index == 1) {
            this.screenFull = new ScreenFull(this.options);
        }
    }

    render() {
        this.$el = $(tmpl(this.options));
        if(this.screen.width > 0) {
            this.$el.css({
                // width: `${this.screen.width}px`,
                height: `${this.screen.clientHeight}px`
            });
        }
        
        this.$parent.append(this.$el);
        this.$loading = this.$el.find('.loading');
        this.$box = this.$el.find('.img-box');
    }

    load(lazy = true) {
        if(lazy && !this.$image) {
            this.$image = createImage.call(this, this.options.src);
        }
        return this;
    }

    /* 获取当前元素 */
    getElement() {
        return this.$el[0];
    }

    /* 将当前页定位到可视区域 */
    scrollIntoView() {
        // 则元素的顶部将尽可能滚动到与父元素可见区域顶部对齐的位置，这是默认值
        setTimeout(() => {
            this.getElement().scrollIntoView();
        }, 0);
    }

    /* 获取当前页面相关信息 */
    getMetadata() {
        return {
            index: this.options.index,
            src: this.options.src,
            width: this.$el.width(),
            height: this.$el.height()
        };
    }

    /* 销毁dom元素中的img */
    removeImg() {
        this.$loading.hide()
        this.$image && this.$image.remove()
        this.removeMark = true
    }

    addImg() {
        this.$loading.show()
        this.$image = createImage.call(this, this.options.src);
        this.removeMark = false
    }
}

export default PageView;